const baseApiURL = process.env.REACT_APP_API_URL + (process.env.REACT_APP_API_URL.endsWith("/") ? "" : "/");

export default function () {
    return {
        baseApiURL: baseApiURL,
        chartUrl: `${baseApiURL}charts/`,
        logicUrl: `${baseApiURL}logics`,
        loginUrl: `${baseApiURL}authenticate`,
        userManagementUrl: `${baseApiURL}users`,
        updatePasswordUrl: `${baseApiURL}updatePassword`,
        databaseUrl: `${baseApiURL}database`,
        segmentationUrl: `${baseApiURL}internal/segmentation`
    }
}
